import api from "../../../services/api";

const getMenus = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/role/check/" + state.idMenu).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTMENU", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const updatePassword = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/password/" + state.idPass, state.temp_pass).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getProgress = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/progress/" + state.idUser).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_PROGRESS", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const updateUrlImage = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.post("/upload/url/" + state.idUser, state.temp_pass).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const uploadFile = (_, { emp_no, payload }) => {
  return new Promise((resolve, reject) => {
    api
      .post("/upload/" + emp_no, payload, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(
        response => {
          resolve(response);
          return response.data.data;
        },
        error => {
          reject(error);
        }
      );
  });
};
const postCheckMenu = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.post("/check/menu/" + state.idUser, state.temp_cekmenu).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESMENUCEK", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
export default {
  getMenus,
  updateUrlImage,
  uploadFile,
  getProgress,
  updatePassword,
  postCheckMenu
};
